import React from "react";
import { useWebTranslation } from "../../../../translations";
import ChatMessage, {
  ChatContainer,
} from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import Gutter from "../../../../ui-kit/Gutter";
import { FlexRow } from "../../../../ui-kit/Layout/Flex";
import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import FlowInput from "components/Signup/components/FlowInput/FlowInput";
import { useDispatch } from "react-redux";
import { updateAnimalById } from "components/Signup/store/slices/animals";
import { StepProps } from "../types";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";

const AnimalName = ({ previous, next, isValid, transitioning }: StepProps) => {
  const { t } = useWebTranslation();
  const dispatch = useDispatch();
  const animal = useCurrentAnimal();

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>
          {t("signup.animal_name.text_2", {
            species: animal?.species ?? "",
          })}
        </Typography>
      </ChatMessage>
      <Gutter size={2} />
      <ChatMessage fromMe>
        <FlexRow alignItems="baseline" style={{ position: "relative" }}>
          <span aria-hidden>
            {animal?.species === SpeciesEnum.dog ? `🐶` : "🐱 "}
          </span>
          <FlowInput
            aria-label={t("a11y.signup.animal_name.label")}
            placeholder={t("signup.animal_name.placeholder")}
            onChange={(name: string) =>
              dispatch(
                updateAnimalById({
                  id: animal.id,
                  update: { name: name.trim() },
                })
              )
            }
            onEnter={() => isValid && next()}
            value={animal.name ?? undefined}
            style={{
              width: animal.name?.length
                ? `max(calc(${animal.name?.length}ch + 16px), 150px)`
                : 150,
              paddingLeft: 8,
            }}
          />
        </FlexRow>
      </ChatMessage>
      <FlowButtons
        inProgress={transitioning}
        next={next}
        disabled={!isValid}
        previous={previous}
        backButton={false}
      />
    </ChatContainer>
  );
};

export default AnimalName;
